import { App } from '@gin-betting/core';
import { OrderedSet, Record } from 'immutable';

import { Actions } from './actions';
import {
    ADD_MATCH_ID,
    CHANGE_VIEWER_MODE,
    CLEAR_MATCH_IDS,
    CLOSE_FULLSCREEN_STREAM,
    DELETE_MATCH_ID,
    OPEN_FULLSCREEN_STREAM,
    PIN_STREAM,
    REMOVE_LAST_PLAYED_STREAM_MATCH_ID,
    RESET_VIEWER_MODE,
    SET_LAST_PLAYED_STREAM_MATCH_ID,
    SET_LOAD_STATUS,
    UNPIN_STREAM,
    ViewerMode,
} from './constants';
import { StreamState, StreamStateShape } from './types';

const StreamStateRecord = Record<StreamStateShape>(
    {
        lastPlayedStreamMatchId: null,
        pinnedStreamMatchId: null,
        matchIdFullScreen: null,
        isUserPinnedStream: false,
        matchIds: OrderedSet(),
        matchTrackerStatus: App.FetchStatus.INITIAL,
        viewerMode: ViewerMode.NONE,
    },
    'StreamState'
);

const initialState: StreamState = new StreamStateRecord();

export default function reducer(
    state = initialState,
    action: Actions
): StreamState {
    switch (action.type) {
        case OPEN_FULLSCREEN_STREAM: {
            const { matchId } = action.payload;

            return state.set('matchIdFullScreen', matchId);
        }

        case CLOSE_FULLSCREEN_STREAM: {
            return state.set('matchIdFullScreen', null);
        }

        case PIN_STREAM: {
            const { matchId } = action.payload;

            return state.set('pinnedStreamMatchId', matchId);
        }

        case UNPIN_STREAM: {
            return state.delete('pinnedStreamMatchId');
        }

        case ADD_MATCH_ID: {
            const { matchId, withClearPrev } = action.payload;

            const { matchIds } = state;

            const nextMatchIds = (withClearPrev
                ? matchIds.clear()
                : matchIds
            ).add(matchId);

            return state
                .set('matchIds', nextMatchIds)
                .set('viewerMode', ViewerMode.NONE);
        }

        case DELETE_MATCH_ID: {
            const { matchId } = action.payload;
            const { matchIds } = state;
            const nextMatchIds = matchIds.delete(matchId);

            return state.set('matchIds', nextMatchIds);
        }

        case CLEAR_MATCH_IDS: {
            const { matchIds } = state;
            const nextMatchIds = matchIds.clear();

            return state.set('matchIds', nextMatchIds);
        }

        case SET_LAST_PLAYED_STREAM_MATCH_ID: {
            const { matchId } = action.payload;

            return state.set('lastPlayedStreamMatchId', matchId);
        }

        case REMOVE_LAST_PLAYED_STREAM_MATCH_ID: {
            return state.delete('lastPlayedStreamMatchId');
        }

        case SET_LOAD_STATUS: {
            const { loadStatus } = action.payload;

            return state.set('matchTrackerStatus', loadStatus);
        }

        case CHANGE_VIEWER_MODE: {
            const { viewerMode } = action.payload;

            return state.set('viewerMode', viewerMode);
        }

        case RESET_VIEWER_MODE: {
            return state.set('viewerMode', ViewerMode.NONE);
        }

        default:
            return state;
    }
}
